import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { Button } from '@/components/ButtonComponent';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';
import { useFirstValidationErrorMessage } from '@/feature/betslip-pickem/hooks/use-betslip-data';
import { lobbyId } from '@/feature/lobby/hooks/use-lobby-section-selection';
import { PickemLobbyTabNavigationProp } from '@/navigation/pickem/types';
import { common } from '@/styles/styles';

const styles = StyleSheet.create({
    root: {
        paddingHorizontal: 24,
        minHeight: 200,
    },
});

export const EmptyPickSlipInfo = ({ betslipLength }: { betslipLength?: number }) => {
    const { t } = useTranslation('betslip_pickem');
    const navigation = useNavigation<PickemLobbyTabNavigationProp>();
    const isListEmpty = betslipLength === 0;
    const errorMessage = useFirstValidationErrorMessage();

    const handlePress = () => {
        navigation.popTo('PickemHome', {
            screen: 'Lobby',
            params: {
                screen: 'LobbyScreen',
                params: { league: lobbyId },
            },
        });
    };

    return (
        <View style={[common.alignCenter, common.paddingHorizontal, common.justifyCenter, common.flex, styles.root]}>
            <Text variant={'headlineMedium'}>{t(isListEmpty ? 'no_players_added' : 'need_more_players')}</Text>
            {errorMessage ? (
                <>
                    <SizedBox value={8} />
                    <Text variant={'bodySmall'} color={ds.colorToken.text.secondary} textAlign={'center'}>
                        {errorMessage}
                    </Text>
                </>
            ) : null}
            <SizedBox value={20} />
            <Button label={t('add_players')} shape="rect" hierarchy={'primary'} onPress={handlePress} />
        </View>
    );
};
